import styles from './styles.less';

// Module
import routes from './routes';
import ApiModuleServices from './services';


export default angular.module('app.main.apiTest.module',[ ApiModuleServices ])
	.config(routes)
	.name



/** WEBPACK FOOTER **
 ** ./src/main/apiTest/index.js
 **/